import script from "./BackButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackButton.vue?vue&type=script&setup=true&lang=ts"

import "./BackButton.vue?vue&type=style&index=0&id=20f925c0&lang=css"

const __exports__ = script;

export default __exports__